import { useMutation } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUIUserFavoriteValidationResult } from "../../services/ui-personalization-data-service/Models";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

export type UseValidateUserFavoriteParameters = {
} & BaseUseMutationParameters<IUIUserFavoriteValidationResult, { favoriteID: number; }>;

export function useValidateUserFavorite({
    onError,
    onSuccess
}: UseValidateUserFavoriteParameters) {

    return useMutation<IUIUserFavoriteValidationResult, RestError, { favoriteID: number; }>(
        async (params) => {
            return UIPersonalizationDataService.validateUserFavorite(params.favoriteID);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
